import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/modules/layout/components/client-link-btn/index.tsx");
